import { atom } from "jotai";
import { LocaleType } from "@/model";

const localeAtom = atom<LocaleType>("ko");

export default localeAtom;
